

<template>
  <router-view class="mainRouter" v-slot="slotProps">
    <transition name="route" mode="out-in">
      <component :is="slotProps.Component"></component>
    </transition>
  </router-view>
  <the-header class="header"></the-header>
</template>

<script>
import TheHeader from './components/layout/TheHeader.vue'

export default {
   components: {
            TheHeader: TheHeader
        },
    
     created() {
        this.loadMembers();
        this.loadGroups();

      },

      methods: {
        async loadMembers() {
          await this.$store.dispatch('members/loadMembers')
        },
        async loadGroups() {
          await this.$store.dispatch('groups/fetchGroups')
        }
        
      }
}

</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");

#app {
  font-family: "Roboto", sans-serif, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
}

.mainRouter {
  padding-bottom: 3rem;
}

.header {
  z-index: 100;
  position: fixed;
  bottom: 0;
}

#nav {
  padding: 30px;
}

li {
  padding: 0.07rem;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.route-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}

.route-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.route-enter-active {
  transition: all 0.3s ease-out;
}

.route-leave-active {
  transition: all 0.3s ease-in;
}

.route-enter-to .route-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
